const DEFAULT_PREFIX = 'R$ ';
const DEFAULT_SUFFIX = '';
const DEFAULT_CARDINALS = [
  ['mil', 'mil'],
  ['milhão', 'milhões'],
  ['bilhão', 'bilhões'],
  ['trilhão', 'trilhões'],
  ['quatrilhão', 'quatrilhões'],
];

function prefix(options) {
  return [null, undefined].includes(options.prefix) ? DEFAULT_PREFIX : options.prefix;
}

function suffix(options) {
  return [null, undefined].includes(options.suffix) ? DEFAULT_SUFFIX : options.suffix;
}

function prepend(value) {
  if (value < 10) {
    return '00';
  }

  if (value < 100) {
    return '0';
  }

  return '';
}

export function demonetize(value = '') {
  return parseInt(String(value).replace(/\D/g, ''), 10) || 0;
}

export default function monetize(value = '', options = {}) {
  let cents = demonetize(value);

  if (cents) {
    cents = `${prepend(cents)}${cents}`
      .replace(/(\d{2})$/, ',$1')
      .replace(/(\d+)(\d{3},\d{2})$/g, '$1.$2');

    for (let i = 0, l = (cents.length - 3) / 3; l > i; i += 1) {
      cents = cents.replace(/(\d+)(\d{3}.*)/, '$1.$2');
    }
  }

  return `${prefix(options)}${cents || '0,00'}${suffix(options)}`;
}

export function round(value = '', options = {}) {
  let cents = String(demonetize(value));

  // < 10 mil & >= 1 quintilhão
  if (cents.length < 7 || cents.length > 20) {
    return monetize(value, options);
  }

  const power = [
    undefined,
    ...(options.cardinals || DEFAULT_CARDINALS),
  ];

  while (cents >= 100000) {
    power.shift();
    cents = cents.slice(0, -3);
  }

  if (power.length === 0) {
    return monetize(value, options);
  }

  cents = String(cents / 100).split('.');

  if (cents[1]) {
    cents[1] = cents[1].slice(0, 1);
  }

  cents = cents[1] === '0' ? cents[0] : cents.join('.');

  return `${prefix(options)}${cents} ${power[0][cents === '1' ? 0 : 1]}${suffix(options)}`;
}
